import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.Toggler = function () {
        var _instance = this;

        this.$accordionElement = $('.accordion .toggler');
        this.$togglerElement = $(':not(.accordion) > .toggler');
        this.$accordionElementHead = $('.togglerHead', this.$accordionElement);
        this.$togglerElementHead = $('.togglerHead', this.$togglerElement);
        this.displayTogglerAsNormalCeOnDesktopArray = this.getSettings(this.$togglerElement);
        this.displayAccordionAsNormalCeOnDesktopArray = this.getSettings(this.$accordionElement);
        this.$window = $(window);

        this.$window.on('load', function () {
            _instance.checkIfTogglerShouldBeDisplayed();
        });
        this.$window.on('resize', function () {
            _instance.checkIfTogglerShouldBeDisplayed();
        });

        this.$accordionElementHead.on('click', function (e) {
            e.stopPropagation();
            _instance.accordionAnimation(e);
        });
        this.$togglerElementHead.on('click', function (e) {
            e.stopPropagation();
            _instance.togglerAnimation(e);
        });

    };

    OndigoNS.Toggler.prototype = {
        getSettings: function ($items) {
            var arr = [], i = 0;
            for (i; i < $items.length; i++) {
                arr[i] = $items.eq(i).hasClass('displayAsNormalCeOnDesktop');
            }
            return arr;
        },
        checkIfTogglerShouldBeDisplayed: function () {
            if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointWide) {
                this.$accordionElement.removeClass('displayAsNormalCeOnDesktop');
                this.$togglerElement.removeClass('displayAsNormalCeOnDesktop');
            } else {
                var i, className;
                for (i = 0; i < this.displayTogglerAsNormalCeOnDesktopArray.length; i++) {
                    className = this.displayTogglerAsNormalCeOnDesktopArray[i] === true ? 'displayAsNormalCeOnDesktop' : '';
                    this.$togglerElement.eq(i).addClass(className);
                }

                for (i = 0; i < this.displayAccordionAsNormalCeOnDesktopArray.length; i++) {
                    className = this.displayAccordionAsNormalCeOnDesktopArray[i] === true ? 'displayAsNormalCeOnDesktop' : '';
                    this.$accordionElement.eq(i).addClass(className);
                }
            }
        },
        togglerAnimation: function (e) {
            var $currentToggler = $(e.target).parents('.toggler').first(),
                $currentTogglerContent = $currentToggler.find('.togglerContent').first(),
                currentTogglerSpeed = $currentToggler.data('speed') || 400,
                isOpening = $currentToggler.hasClass('closed');

            if (!$currentToggler.hasClass('displayAsNormalCeOnDesktop')) {

                $currentTogglerContent.slideToggle(currentTogglerSpeed, function() {
                    if(isOpening) {
                        if (OndigoNS.VideoJS) {
                            OndigoNS.VideoJS.reloadPlayer($currentTogglerContent);
                        }
                    }
                });

                $currentToggler.toggleClass('closed');
            }

        },
        accordionAnimation: function (e) {
            var $currentAccordion = $(e.target).parents('.toggler'),
                $openedAccordion = $currentAccordion.parents('.accordion').find('.opened');

            if (!$currentAccordion.hasClass('displayAsNormalCeOnDesktop')) {

                if ($currentAccordion.hasClass('closed')) {
                    $currentAccordion.removeClass('closed').addClass('opened').find('.togglerContent').slideDown(400, function() {
                        if (OndigoNS.VideoJS) {
                            OndigoNS.VideoJS.reloadPlayer($currentAccordion);
                        }
                    });
                }

                if ($openedAccordion.length) {
                    $openedAccordion.removeClass('opened').addClass('closed').find('.togglerContent').slideUp();
                }

            }

        }
    };

    // plugin definition
    $.fn.initializeToggler = function () {
        return new OndigoNS.Toggler();
    };
    $.fn.initializeToggler.Constructor = OndigoNS.Toggler;

}(window.jQuery));


$(document).ready(function () {
    'use strict';

    var $toggler = $('.toggler');

    if ($toggler.length) {
        $toggler.initializeToggler();
    }
});